import React, { memo } from 'react';

import { useIntl } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';
import Tooltip from '@atlaskit/tooltip';

import messages from './messages';

export const PendingStatus = memo(({ showOptimalTooling }: { showOptimalTooling?: boolean }) => {
	const { formatMessage } = useIntl();
	return showOptimalTooling ? (
		<Tooltip content={formatMessage(messages.pendingTooltip)} position="right">
			<Lozenge appearance="moved">{formatMessage(messages.pending)}</Lozenge>
		</Tooltip>
	) : (
		<Lozenge appearance="moved">{formatMessage(messages.pending)}</Lozenge>
	);
});

export const ResponsiveStatus = memo(({ showOptimalTooling }: { showOptimalTooling?: boolean }) => {
	const { formatMessage } = useIntl();
	return showOptimalTooling ? (
		<Tooltip content={formatMessage(messages.responsiveTooltip)} position="right">
			<Lozenge appearance="success">{formatMessage(messages.responsive)}</Lozenge>
		</Tooltip>
	) : (
		<Lozenge appearance="success">{formatMessage(messages.responsive)}</Lozenge>
	);
});

export const UnresponsiveStatus = memo(
	({ showOptimalTooling }: { showOptimalTooling?: boolean }) => {
		const { formatMessage } = useIntl();
		return showOptimalTooling ? (
			<Tooltip content={formatMessage(messages.unresponsiveTooltip)} position="right">
				<Lozenge appearance="removed">{formatMessage(messages.unresponsive)}</Lozenge>
			</Tooltip>
		) : (
			<Lozenge appearance="removed">{formatMessage(messages.unresponsive)}</Lozenge>
		);
	},
);

export const OffStatus = memo(({ showOptimalTooling }: { showOptimalTooling?: boolean }) => {
	const { formatMessage } = useIntl();
	return showOptimalTooling ? (
		<Tooltip content={formatMessage(messages.offTooltip)} position="right">
			<Lozenge>{formatMessage(messages.off)}</Lozenge>
		</Tooltip>
	) : (
		<Lozenge>{formatMessage(messages.off)}</Lozenge>
	);
});
